<template>
  <div>文章编辑</div>
</template>

<script>
  export default {
    name: "article-edit"
  }
</script>

<style scoped>

</style>
